"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const prop_types_1 = __importDefault(require("prop-types"));
const get_css_1 = __importDefault(require("../get-css"));
exports.propTypes = {
    boxShadow: prop_types_1.default.string
};
exports.propAliases = {};
exports.propValidators = {};
const boxShadow = {
    className: 'bs',
    cssName: 'box-shadow',
    jsName: 'boxShadow',
    complexValue: true
};
exports.propEnhancers = {
    boxShadow: (value) => get_css_1.default(boxShadow, value)
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYm94LXNoYWRvdy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9lbmhhbmNlcnMvYm94LXNoYWRvdy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7OztBQUFBLDREQUFrQztBQUNsQyx5REFBK0I7QUFHbEIsUUFBQSxTQUFTLEdBQXFCO0lBQ3pDLFNBQVMsRUFBRSxvQkFBUyxDQUFDLE1BQU07Q0FDNUIsQ0FBQTtBQUVZLFFBQUEsV0FBVyxHQUFnQixFQUFFLENBQUE7QUFFN0IsUUFBQSxjQUFjLEdBQW1CLEVBQUUsQ0FBQTtBQUVoRCxNQUFNLFNBQVMsR0FBRztJQUNoQixTQUFTLEVBQUUsSUFBSTtJQUNmLE9BQU8sRUFBRSxZQUFZO0lBQ3JCLE1BQU0sRUFBRSxXQUFXO0lBQ25CLFlBQVksRUFBRSxJQUFJO0NBQ25CLENBQUE7QUFFWSxRQUFBLGFBQWEsR0FBa0I7SUFDMUMsU0FBUyxFQUFFLENBQUMsS0FBNEIsRUFBRSxFQUFFLENBQUMsaUJBQU0sQ0FBQyxTQUFTLEVBQUUsS0FBSyxDQUFDO0NBQ3RFLENBQUEifQ==